import { Paper } from "@mantine/core";
import { Headers } from "../components/ui/heading";
import FileUploadPage from "../components/BulkUploads/FileUpload/FileUploadPage";

function FileUpload() {
  return (
    <div className="-m-4 min-h-screen flex flex-col pb-16 bg-white-700">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="flex-shrink-0 [&>div]:mb-0">
          <Headers
            name={
              <span className="text-gray-600 text-base">
                PAYMENTS {" > "} BULK PAYMENTS
              </span>
            }
            subtitle={
              <span className="text-gray-900 capitalize text-lg font-bold">
                Bulk Payments
              </span>
            }
          />
        </div>
      </Paper>
      <FileUploadPage />
    </div>
  );
}

export default FileUpload;
